<template>
  <Card>
    <AjaxForm route="admin/app/CostCoinEdit" v-if="data">
      <div class="row">
        <div class="col-12 col-md-4">
          <CustomInput type="number" v-model="data.ladder" name="ladder" input_style="twoLine" label="قیمت نردبان"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="number" v-model="data.instant"  name="instant" input_style="twoLine" label="قیمت فوری"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="number" v-model="data.disposable_cost"  name="disposable_cost" input_style="twoLine" label="قیمت سکه یکبار مصرف"></CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 col-sm-8 col-10 mx-auto">
          <button class="btn btn-info btn-block" type="submit">ویرایش قیمت ها</button>
        </div>
      </div>
    </AjaxForm>
  </Card>
</template>

<script>
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";
import Card from "@/components/forms/Card";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";

export default {
  name: "coinCost",
  components: {AjaxForm, CustomInput, Card},
  data()
  {
    return {
      data : null,
    }
  },
  mounted()
  {
    this.setPageTitle('قیمت گذاری نردبان،فوری و سکه یکبار مصرف');
    this.setShowHead(true);
    this.setPageLoading(false);
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.data = null;
      this.setPageLoading(true);
      const result = await AppApi.getCoinCostInfo();
      if (result.ok)
      {
        this.data = result.data;
        console.log(this.data.ladder);
      }
      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>

</style>